import React, { useContext, useState } from 'react';
import { InputGroup } from 'reactstrap';
import ClipboardButton from '../../../../Atoms/buttons/ClipboardButton';
import { RoutingS } from '../../../../Service/RoutingS';
import { WindowContext } from '../../../../Service/Context/WindowContext';
import { IconCalendarPlus } from '@tabler/icons';
import { Button } from '@mantine/core';

export const Subscription = ({ calendarSubscriptionId, entityType }) => {
  const { md } = useContext(WindowContext);
  const [url] = useState(
    `${process.env.REACT_APP_CALDAV_SERVICE_URL}/subscriptions/${entityType}/${calendarSubscriptionId}.ics`,
  );

  const styles = {
    codeField: {
      height: 34,
      borderRadius: 5,
      marginRight: 4,
    },
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 15 }}>
      <InputGroup style={{ maxWidth: 600 }}>
        <input readOnly className="code form-control" style={styles.codeField} value={url} />
        <ClipboardButton text={url} />
      </InputGroup>
      {md && (
        <Button
          pl={0}
          variant="subtle"
          leftIcon={<IconCalendarPlus size={20} />}
          onClick={() => RoutingS.openInNewTab(url?.replace(/^https:/, 'webcal:'))}
        >
          Kalender abonnieren
        </Button>
      )}
    </div>
  );
};
